import { Box, Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';

export function ManagingRecentInheritance() {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '70%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Card variant="filled" sx={{ p: 2 }}>
          <Stack spacing={2}>
            <EditableRegion regionId="description" />
          </Stack>
        </Card>
        <EditableRegion regionId="left-column" />
      </Box>
      <Box
        sx={{
          width: '30%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Stack spacing={2}>
            <EditableRegion regionId="right-column" />
          </Stack>
        </Card>
      </Box>
    </Box>
  );
}
